'use strict';

module.exports = {
  APICall: require('./api-call').default,
  WebSocket: require('./websocket').default
};


//////////////////
// WEBPACK FOOTER
// ./~/mindself-api-client/lib/middlewares/index.js
// module id = 199
// module chunks = 1